<!-- 手工创建 -->
<template>
  <div>
    <!-- <div class="header-title">{{ `${pageType}采购计划` }}</div> -->
    <!-- 表单 -->
    <div class="container">
      <div class="commodity-list">
        <div class="title">基本信息</div>
        <el-form
          ref="formRef1"
          style="margin-top: 20px"
          label-width="140px"
          :model="formData"
          :rules="rules"
          @submit.native.prevent
        >
          <el-row>
            <el-col :span="16">
              <el-form-item label="采购计划名称：" prop="purchasePlanName">
                <el-input
                  v-model="formData.purchasePlanName"
                  maxlength="100"
                  size="small"
                  placeholder="请输入采购计划名称"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="概算金额："
                >{{ budgetaryTotalAmount }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="产品批号：">
                <el-input
                  v-model="formData.productBatchNumber"
                  maxlength="100"
                  size="small"
                  placeholder="请输入产品批号"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- v-if="pageType == '创建'" -->
          <el-row v-if="pageType === 'add'">
            <el-col :span="8">
              <el-form-item label="需求部门：">
                <el-input
                  v-model="formData.orgShortName"
                  size="small"
                  placeholder="请选择部门"
                  @focus="handleFocusBtn('branch')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
          <el-form-item label="关联预算：">
            <el-input
              size="small"
              placeholder="请选择预算"
              :disabled="!this.formData.orgId"
              @focus="handleFocusBtn('budget')"
              v-model="formData.budgetName"
            ></el-input>
          </el-form-item>
        </el-col> -->
          </el-row>
        </el-form>
      </div>
    </div>

    <!-- form-table v-if="pageType == '创建'"-->
    <div class="container" style="padding-top: 20px">
      <div
        v-if="
          pageType === 'add' ||
          (isDemandCreate === '0' && pageType === 'change')
        "
        style="display: flex; margin-bottom: 10px"
      >
        <eui-btn class="btn-main-more" @click="handleAddMaterial"
          >添加物料</eui-btn
        >
        <eui-btn class="btn-main-more btn-th" @click="handleImportAll"
          >批量导入</eui-btn
        >
      </div>
      <div class="commodity-list">
        <div class="title">物料信息</div>

        <el-form
          ref="tableForm"
          class="table-content"
          :model="tableFormData"
          :rules="rules_table"
          @submit.native.prevent
        >
          <!-- <pre>{{ tableFormData.tableData }}</pre> -->
          <el-table
            :data="tableFormData.tableData"
            v-bind="bindMaxHeight()"
            :header-cell-class-name="'verify'"
            border
            style="width: 100%"
          >
            <template slot="empty">
              <div class="custom-empty">暂无数据</div>
            </template>
            <el-table-column
              type="index"
              width="50"
              align="center"
              label="序号"
              fixed="left"
            ></el-table-column>
            <!-- <el-table-column
            width="180"
            prop="letVal"
            align="center"
            label="物料分类"
            v-if="pageType === 'add' || pageType === 'change'"
          >
            <template slot="header">
              <span>
                <span class="table-active-i">*</span>
                物料分类
              </span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :rules="rules_table.categoryName"
                :ref="`tableData.${scope.$index}.categoryName`"
                :prop="`tableData.${scope.$index}.categoryName`"
              >
                <el-input
                  maxlength="30"
                  placeholder="请输入"
                  size="small"
                  clearable
                  v-model.trim="scope.row.categoryName"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column> -->
            <el-table-column
              width="180"
              prop="letVal"
              align="center"
              label="物料分类"
            >
              <template slot-scope="scope">
                <el-form-item>{{ scope.row.categoryName }}</el-form-item>
              </template>
            </el-table-column>
            <!-- v-if="pageType == '创建'" -->
            <el-table-column
              v-if="
                pageType === 'add' ||
                (pageType === 'change' && isDemandCreate === '0')
              "
              width="200"
              label="物料编码"
              align="center"
              prop="categoryCustomCode"
            >
              <!-- :rules="rules_table.categoryCustomCode" -->
              <template slot-scope="scope">
                <el-form-item
                  :ref="`tableData.${scope.$index}.categoryCustomCode`"
                  :prop="`tableData.${scope.$index}.categoryCustomCode`"
                >
                  <el-input
                    v-model.trim="scope.row.categoryCustomCode"
                    maxlength="30"
                    placeholder="请输入"
                    size="small"
                    clearable
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column v-else width="140" align="center" label="物料编码">
              <template slot-scope="scope">
                <el-form-item>{{
                  scope.row.categoryCustomCode || '-'
                }}</el-form-item>
              </template>
            </el-table-column>
            <!--  v-if="pageType == '创建'" -->
            <el-table-column
              v-if="
                pageType === 'add' ||
                (pageType === 'change' && isDemandCreate === '0')
              "
              align="center"
              width="300"
              prop="categoryDesc"
            >
              <template slot="header">
                <span>
                  <span class="table-active-i">*</span>
                  物料描述
                </span>
              </template>
              <template slot-scope="scope">
                <el-form-item
                  :ref="`tableData.${scope.$index}.categoryDesc`"
                  class="table-desc"
                  :rules="rules_table.categoryDesc"
                  :prop="`tableData.${scope.$index}.categoryDesc`"
                >
                  <el-input
                    v-model="scope.row.categoryDesc"
                    type="textarea"
                    show-word-limit
                    :rows="1"
                    maxlength="100"
                    placeholder="请输入"
                    size="small"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column v-else width="140" align="center" label="物料描述">
              <template slot-scope="scope">
                <el-form-item>{{ scope.row.categoryDesc }}</el-form-item>
              </template>
            </el-table-column>
            <!-- v-if="pageType == '创建'" -->
            <el-table-column
              v-if="
                pageType === 'add' ||
                (pageType === 'change' && isDemandCreate === '0')
              "
              prop="baseUnitName"
              width="160"
              align="center"
            >
              <template slot="header">
                <span>
                  <span class="table-active-i">*</span>
                  计量单位
                </span>
              </template>
              <template slot-scope="scope">
                <el-form-item
                  :ref="`tableData.${scope.$index}.baseUnitName`"
                  :rules="rules_table.baseUnitName"
                  :prop="`tableData.${scope.$index}.baseUnitName`"
                >
                  <!--                  <el-select-->
                  <!--                    v-model="scope.row.baseUnitName"-->
                  <!--                    placeholder="请选择"-->
                  <!--                    size="small"-->
                  <!--                    @focus="getBaseUnitName(scope.row.categoryId)"-->
                  <!--                    @change="-->
                  <!--                      baseUnitNameChange(scope.row.categoryId, scope.$index)-->
                  <!--                    "-->
                  <!--                  >-->
                  <!--                    <el-option-->
                  <!--                      v-for="item in baseUnitNameList"-->
                  <!--                      :key="item.categoryUnitId"-->
                  <!--                      :label="item.unitName"-->
                  <!--                      :value="item.unitName"-->
                  <!--                    ></el-option>-->
                  <!--                  </el-select>-->

                  <el-input
                    v-model.trim="scope.row.baseUnitName"
                    maxlength="10"
                    class="edit-input"
                    size="small"
                    placeholder="计量单位"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column v-else width="100" align="center" label="计量单位">
              <template slot-scope="scope">
                <el-form-item>{{ scope.row.baseUnitName }}</el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="规格型号" min-width="220" align="center">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`tableData.${scope.$index}.specifications`"
                  :rules="rules_table.specifications"
                >
                  <el-input
                    v-model.trim="scope.row.specifications"
                    maxlength="100"
                    show-word-limit
                    class="edit-input"
                    size="small"
                    placeholder="规格型号"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="remainingQuantity"
              width="160"
              align="center"
              label="采购数量"
            >
              <template slot="header">
                <span>
                  <span class="table-active-i">*</span>
                  采购数量
                </span>
              </template>
              <template slot-scope="scope">
                <el-form-item
                  :ref="`tableData.${scope.$index}.remainingQuantity`"
                  :rules="rules_table.remainingQuantity"
                  :prop="`tableData.${scope.$index}.remainingQuantity`"
                >
                  <el-input
                    v-model.trim="scope.row.remainingQuantity"
                    maxlength="30"
                    placeholder="请输入"
                    size="small"
                    @change="
                      handleInputBlur(
                        scope.row,
                        scope.$index,
                        'remainingQuantity'
                      )
                    "
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="budgetaryPrice"
              width="160"
              align="center"
              label="概算单价（元）"
            >
              <!-- <template slot="header">
              <span>
                <span class="table-active-i">*</span>
                概算单价（元）
              </span>
            </template> -->
              <template slot-scope="scope">
                <el-form-item
                  :ref="`tableData.${scope.$index}.budgetaryPrice`"
                  :rules="rules_table.budgetaryPrice"
                  :prop="`tableData.${scope.$index}.budgetaryPrice`"
                >
                  <!-- oninput="value=value.replace(/[^0-9.]/g,'')"
                  @change="handleInputBlur(scope.row, scope.$index, 'budgetaryPrice')" -->
                  <el-input
                    v-model.trim="scope.row.budgetaryPrice"
                    maxlength="30"
                    placeholder="请输入"
                    size="small"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="expectedArrivalDate"
              width="240"
              align="center"
              label="计划到货日期"
            >
              <template slot="header">
                <span>
                  <span class="table-active-i">*</span>
                  计划到货日期
                </span>
                <i
                  class="el-icon-edit"
                  style="padding: 0 4px; cursor: pointer"
                  @click="
                    () => {
                      changeTimeVisible = true;
                    }
                  "
                ></i>
              </template>
              <template slot-scope="scope">
                <el-form-item
                  :ref="`tableData.${scope.$index}.expectedArrivalDate`"
                  :rules="rules_table.expectedArrivalDate"
                  :prop="`tableData.${scope.$index}.expectedArrivalDate`"
                >
                  <el-date-picker
                    v-model="scope.row.expectedArrivalDate"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerReleaseTimeDate"
                    type="date"
                    placeholder="请选择日期"
                  ></el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="160" align="center" label="图号">
              <template slot="header">
                图号<span
                  class="el-icon-edit"
                  @click="openDialog('imageNumber', '图号')"
                ></span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.imageNumber`">
                  <el-input
                    v-model.trim="scope.row.imageNumber"
                    maxlength="100"
                    show-word-limit
                    class="edit-input"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="160" align="center" label="订货方">
              <template slot="header">
                订货方<span
                  class="el-icon-edit"
                  @click="openDialog('buyer', '订货方')"
                ></span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.buyer`">
                  <el-input
                    v-model.trim="scope.row.buyer"
                    maxlength="100"
                    show-word-limit
                    class="edit-input"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="160" align="center" label="件号">
              <template slot="header">
                件号<span
                  class="el-icon-edit"
                  @click="openDialog('partNumber', '件号')"
                ></span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.partNumber`">
                  <el-input
                    v-model.trim="scope.row.partNumber"
                    maxlength="100"
                    show-word-limit
                    class="edit-input"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="160" align="center" label="标准">
              <template slot="header">
                标准<span
                  class="el-icon-edit"
                  @click="openDialog('standard', '标准')"
                ></span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.standard`">
                  <el-input
                    v-model.trim="scope.row.standard"
                    maxlength="100"
                    show-word-limit
                    class="edit-input"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="160" align="center" label="备注">
              <template slot="header">
                备注<span
                  class="el-icon-edit"
                  @click="openDialog('remark', '备注')"
                ></span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.remark`">
                  <el-input
                    v-model.trim="scope.row.remark"
                    maxlength="100"
                    show-word-limit
                    class="edit-input"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <!--v-if="pageType != '创建'" -->
            <el-table-column
              v-if="pageType !== 'add' && isDemandCreate === '1'"
              label="物料汇总清单"
              fixed="right"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.numFlag >= 2"
                  type="text"
                  @click="handleLook(scope.row)"
                >
                  查看
                </el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <!-- v-if="pageType == '创建'" -->
            <el-table-column
              v-if="
                pageType === 'add' ||
                (isDemandCreate === '0' && pageType === 'change')
              "
              label="附件"
              fixed="right"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <eui-btn
                  type="text"
                  @click="uploadDesc(scope.$index, scope.row)"
                >
                  {{ checkUploadDesc(scope.row) }}
                </eui-btn>
              </template>
            </el-table-column>
            <!-- v-if="pageType == '创建'" -->
            <el-table-column
              v-if="
                pageType === 'add' ||
                (isDemandCreate === '0' && pageType === 'change')
              "
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <eui-btn
                  type="text"
                  @click="handleDelMaterial(scope.$index, scope.row)"
                  >删除</eui-btn
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>
    <div class="container" style="padding-top: 10px">
      <!-- 采购计划 -->
      <div class="commodity-list">
        <div class="title">采购方式</div>
        <div class="produc-type">
          <el-form
            ref="formRef2"
            label-width="140px"
            :model="formData"
            :rules="rules"
            @submit.native.prevent
          >
            <el-form-item
              style="margin-bottom: 0"
              label="采购方式："
              label-width="100px"
              prop="purchaseModeType"
            >
              <el-select
                v-model="formData.purchaseModeType"
                filterable
                size="small"
                clearable
                placeholder="请选择采购方式"
              >
                <el-option
                  v-for="item in formPurchaseTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div
            v-if="formData.purchaseModeType == 5"
            style="margin-left: 10px"
            @click="selectAgreement"
          >
            <span class="table-active-i">*</span>
            <el-link type="primary">{{ agreementTitleName }}</el-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container" style="padding-top: 10px">
      <!-- 备注附件 -->
      <div class="commodity-list">
        <div class="title">备注附件</div>
        <el-form
          style="margin-top: 20px"
          label-width="100px"
          :model="formData"
          :rules="rules"
          @submit.native.prevent
        >
          <el-form-item label="附件：">
            <file-upload
              :limit="10"
              :file-size="30"
              class="remark-upload"
              :upload-url="uploadUrl"
              :verify="true"
              :url="showRemarkList"
              :tips-message="tipsMessage"
              :upload-image="false"
              :accept="'.pdf,.xls,.xlsx,.doc'"
              @getFileInfo="getFileInfo"
            />
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              v-model="formData.remark"
              type="textarea"
              :rows="4"
              maxlength="300"
              show-word-limit
              placeholder="请输入介绍信息"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="container" style="padding-top: 10px">
      <!-- 选择审批流 -->
      <div class="commodity-list" style="margin-top: 10px">
        <div class="title">审批流程设置</div>
        <div class="enquiry-form approval">
          <div v-if="ifSwitch" class="info">
            <div v-if="formData.auditName" class="info">
              <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ formData.auditName }}</span>
            </div>
            <div v-else>
              <img src="@/assets/img/approval/exclamation-mark.png" alt="" />
              请选择审批流程
            </div>
          </div>

          <div v-if="!ifSwitch && authFlag" class="info">
            <img src="@/assets/img/approval/exclamation-mark.png" alt="" />
            <span>贵企业尚未配置审批流。</span>
          </div>
          <div
            v-if="!authFlag && ifSwitch && !approvalList.length"
            class="info"
          >
            <img src="@/assets/img/approval/gray-mark.png" alt="" />
            <span style="color: #c5c5c5"
              >贵企业尚未配置审批流，请联系管理员进行配置。</span
            >
          </div>
          <div v-if="!authFlag && !ifSwitch" class="info">
            <img src="@/assets/img/approval/gray-mark.png" alt="" />
            <span style="color: #c5c5c5"
              >贵企业未启用审批流程，无需选择此项。</span
            >
          </div>

          <div v-if="ifSwitch" class="btn submit-btn">
            <div class="btn-main-more" @click="openApproval">选择审批流程</div>
          </div>
          <div v-if="authFlag && !ifSwitch" class="btn submit-btn">
            <div class="btn-main-more" @click="toSetApprove">配置审批流</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 框架协议弹框 -->
    <e-dialog
      class="agreement-dialog"
      :dialog-title="'选择框架协议'"
      :dialog-type="''"
      :center-dialog-visible="agreementVisible"
      :popup-width="'1000px'"
      :show-btn="false"
      @resetPopupData="resetPopupDataAgreement"
    >
      <!-- searct -->
      <e-search
        :data="agreementData"
        :field-list="agreementList"
        :width="filterInfo.width"
        @handleFilter="handleAgreementFilter"
        @handleReset="handleAgreementReset"
      ></e-search>
      <!-- table -->
      <e-table-list
        style="margin-top: 20px"
        :table-data="agreementTableData"
        :table-label="agreementTableLabel"
        :index-show="true"
      >
        <template #code="tData">
          <el-link
            type="primary"
            :underline="false"
            @click="handleCodeDetail(tData.scope.row)"
          >
            {{ tData.scope.row.agreementCode }}
          </el-link>
        </template>
        <template #options="tData">
          <el-link
            type="primary"
            :underline="false"
            @click="handleSelectAgreement(tData.scope.row)"
          >
            执行框架协议
          </el-link>
        </template>
      </e-table-list>
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="agreementTableData.pageNum"
        :total="agreementDataTotal"
        :page-size.sync="agreementTableData.pageSize"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
      <div class="close-btn">
        <eui-btn @click="resetPopupDataAgreement">关闭</eui-btn>
      </div>
    </e-dialog>

    <!-- 保存 -->
    <div class="submit-box">
      <eui-btn type="secondary" @click="handleGoBack">取消</eui-btn>
      <div>
        <eui-btn @click="verifyformRef('save')">保存</eui-btn>
        <eui-btn @click="verifyformRef('submit')">提交</eui-btn>
      </div>
    </div>

    <!-- 上传物料附件 -->
    <file-material-dia
      :material-file-visible.sync="materialFileVisible"
      :show-file-list="showFileList"
      @getMaterialFile="getMaterialFile"
    />

    <!-- 添加物料 -->
    <add-material-dia
      v-if="addMaterialVisible"
      :add-material-visible.sync="addMaterialVisible"
      @getMaterialList="getMaterialList"
    />
    <!-- 选需求部门 -->
    <select-department-dia
      v-if="selectDepartmentDialogShow"
      :visible="selectDepartmentDialogShow"
      @close="closeSelectDepartmentDialog"
      @getNode="getCurrentNode"
    ></select-department-dia>
    <!-- 关联预选 -->
    <budget-dia
      v-if="formData.orgId"
      :budget-visible.sync="budgetVisible"
      :org-id="formData.orgId"
      @chooseData="chooseData"
    />
    <!-- 批量导入 -->
    <batch-import
      :batch-import-visible.sync="batchImportVisible"
      @getbatchImportList="getbatchImportList"
    />
    <!-- 选择审批流弹窗 -->
    <approve
      :show-audit-mask.sync="showAuditMask"
      :approval-list="approvalList"
      @getApprovalChain="getApprovalChain"
    />
    <!-- 修改期望到货日期弹窗 -->
    <change-time
      :change-time-visible.sync="changeTimeVisible"
      @submitChangeTime="submitChangeTime"
    />
    <!-- 查看 -->
    <e-dialog
      :dialog-title="'物料汇总清单'"
      :center-dialog-visible="lookVisible"
      :popup-width="'1000px'"
      :is-show-cancel="false"
      @submitPopupData="resetPopupDataLook"
      @resetPopupData="resetPopupDataLook"
    >
      <e-table-list
        style="margin-top: 20px"
        :table-data="detailTableData"
        :max-height="'500px'"
        :table-label="detailTableLabel"
        :index-show="true"
      >
        <template #code="tData">
          <el-link
            :underline="false"
            type="primary"
            @click="handleDemandDetail(tData.scope.row)"
          >
            {{ tData.scope.row.purchaseDemandCode }}
          </el-link>
        </template>
        <template #company="tData">
          <el-link
            :underline="false"
            type="primary"
            @click="
              handleExportDatail(
                tData.scope.row.purchaseDemandItemAttachmentDetailVOS
              )
            "
          >
            {{
              getAttachmentName(
                tData.scope.row.purchaseDemandItemAttachmentDetailVOS
              )
            }}
          </el-link>
        </template>
      </e-table-list>
    </e-dialog>
    <!-- 批量输入-->
    <change-data-dialog
      v-if="dataVisible"
      :bitch-data="bitchData"
      :data-visible="dataVisible"
      @bitchChangeData="bitchChangeData"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import eDialog from '@/modules/projectA/components/common/e-dialog';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import enApi from '@/modules/projectA/api/enquiry/index';
import Api from '@/modules/projectA/api/purchase';
import currency from 'currency.js';
import utils from '@/modules/projectA/utils/utils';
import _ from 'lodash';
import BudgetDia from '../../demand/components/budgetDia.vue';
import BatchImport from '../components/batchImport.vue';
import Approve from '../components/approveDia.vue';
import AddMaterialDia from '../components/addMaterialDia.vue';
import FileMaterialDia from '../../demand/components/fileMaterialDia.vue';
import selectDepartmentDia from '../../demand/components/budgetAddUser.vue';
import FileUpload from '../components/fileUpload.vue';
import ChangeTime from '../components/changeTime.vue';
import changeDataDialog from '../../../components/plan/changeDataDialog';

export default {
  name: 'HandCreated',
  components: {
    eSearch,
    eDialog,
    eTableList,
    FileUpload,
    AddMaterialDia,
    BudgetDia,
    BatchImport,
    ChangeTime,
    Approve,
    FileMaterialDia,
    selectDepartmentDia,
    changeDataDialog,
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf('/requirementList/requirementDetail') == -1) {
      to.meta.tableFormData = null;
      to.meta.formData = null;
    }
    next();
  },

  data() {
    function categoryCustomCode(rule, value, callback) {
      if (!value && value !== 0) {
        return callback(new Error('请输入物料编码'));
      }
      if (value) {
        const reg = /^[0-9A-Za-z]+$/;
        if (!reg.test(value)) {
          return callback(new Error(`只能输入字母和数字`));
        }
        callback();
      }
    }
    function checkNumber(quantity) {
      const numberReg = /^-?\d+(\.\d{1,3})?$/;
      // const numberReg = /^\d+$/;
      return numberReg.test(quantity);
    }
    function validateRequiredQuantity(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入采购数量'));
      }
      if (value <= 0) {
        return callback(new Error(`采购数量应大于0`));
      }
      if (value > 99999.999) {
        return callback(new Error(`数量不可超过99999.999`));
      }

      if (!checkNumber(value)) {
        callback(new Error('请输入3位以内小数'));
      } else {
        callback();
      }
    }
    function validateBudgetaryPriceQuantity(rule, value, callback) {
      if (value) {
        if (value <= 0) {
          return callback(new Error(`概算单价需大于0`));
        }
        if (value > 9999999.99) {
          return callback(new Error(`单价不可超过9999999.99`));
        }
        if (!checkNumber(value)) {
          callback(new Error('概算单价保留两位小数'));
        } else {
          callback();
        }
      } else {
        return callback();
      }
    }
    /* function validateBudgetaryPriceQuantity(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入概算单价"));
      }
      if (value <= 0) {
        return callback(new Error(`概算单价需大于0`));
      }
      if (value > 9999999.99) {
        return callback(new Error(`单价不可超过9999999.99`));
      }
      if (!checkNumber(value)) {
        callback(new Error("概算单价保留两位小数"));
      } else {
        callback();
      }
    } */
    return {
      bitchData: {
        bitchChangeFlag: '',
        bitchChangeTitle: '',
      },
      dataVisible: false,
      authFlag: false,
      submitFlag: '',
      ifSwitch: false,
      lookVisible: false,
      detailTableData: [],
      detailTableLabel: [
        {
          label: '采购需求编号',
          align: 'center',
          slot: 'code',
          fixed: 'left',
          width: '180',
        },
        {
          label: '采购需求名称',
          param: 'purchaseDemandName',
          align: 'center',
          fixed: 'left',
          width: '170',
        },
        {
          label: '需求数量',
          param: 'remainingQuantity',
          align: 'center',
          width: '130',
        },
        {
          label: '需求部门',
          param: 'orgShortName',
          align: 'center',
          width: '170',
        },
        {
          label: '需求申请人',
          param: 'createMemberName',
          align: 'center',
          width: '130',
        },
        {
          label: '期望到货日期',
          param: 'expectedArrivalDate',
          align: 'center',
          width: '160',
        },
        {
          label: '附件',
          fixed: 'right',
          align: 'center',
          slot: 'company',
          width: '140',
        },
      ],
      agreementTitleName: '选择框架协议',
      agreementData: {
        agreementName: '',
        agreementCode: '',
        supplierCompanyName: '',
        createTime: '',
        startDate: '',
        endDate: '',
        specializedSign: 1, // 专属商城
        externalStatus: 2, // 已生效
        // categoryDesc: "",
        pageNum: 1,
        pageSize: 10,
      },
      agreementDataTotal: 0,
      agreementTableData: [],
      agreementTableLabel: [
        {
          label: '框架协议编号',
          align: 'center',
          slot: 'code',
        },
        {
          label: '框架协议名称',
          param: 'agreementName',
          align: 'center',
        },
        {
          label: '供应商',
          param: 'supplierCompanyName',
          align: 'center',
        },
        {
          label: '协议有效期',
          param: 'endDate',
          align: 'center',
          width: '200',
          render: (row) => {
            return `${row.startDate} - ${row.endDate}`;
          },
        },
        { label: '操作', align: 'center', slot: 'options', width: '130' },
      ],
      agreementList: [
        {
          label: '框架协议编号',
          type: 'input',
          value: 'agreementCode',
        },
        {
          label: '框架协议名称',
          type: 'input',
          value: 'agreementName',
        },
        {
          label: '供应商',
          type: 'input',
          value: 'supplierCompanyName',
        },
        {
          label: '协议有效期',
          type: 'date',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd',
          dateType: 'daterange',
        },
      ],
      filterInfo: {
        width: {
          labelWidth: 100,
          itemWidth: 180,
        },
      },
      agreementVisible: false,
      changeTimeVisible: false,
      // pageType: "创建", // add(创建),edit(采购计划编制),change(修改)
      pageType: 'add', // add(创建),edit(采购计划编制),change(修改)
      companyId: '',
      approvalList: [],
      approvalFlag: false,
      showRemarkList: [],
      // 回显文件
      showFileList: [],
      baseUnitNameList: [],
      clickTableIndex: 0,
      materialFileVisible: false,
      showAuditMask: false,
      batchImportVisible: false,
      budgetVisible: false,
      selectDepartmentDialogShow: false,
      addMaterialVisible: false,
      // 批量导入
      materialFileData: {
        attachmentUrl: '',
        attachmentName: '',
      },
      routeData: null,
      tipsMessage: '支持excel、pdf、wrod 格式文件，小于30M',
      uploadUrl: '',
      maxHeight: '400',
      formData: {
        productBatchNumber: '', // 产品批次号
        orgShortName: '', // 组织机构名称
        orgId: '', // 组织机构id
        budgetName: '', // 套用预算名称
        budgetId: null, // 套用预算Id
        purchaseCompanyName: '', // 采购商名称
        purchaseCompanyId: '', // 采购商id
        purchasePlanName: '', // 采购计划名称
        purchaseModeType: null, // 采购计划
        remark: '', // 备注
        budgetaryTotalAmount: '', // 金额概算
        supplierCompanyId: '', // 供应商id
        supplierCompanyName: '',
        purchasePlanItemAOList: [], // 明细数据
        purchasePlanAttachmentAOList: [], // 主表附件数据
        auditId: '', // 审批流id
        auditName: '',
        enableWorkflow: '', // 是否配置了工作流
        protocolCode: '', // 协议编码
        protocolId: '', // 协议id
      },
      cloneTableFormData: [],
      purchaseDemandItemIdList: [],
      rules: {
        purchasePlanName: [
          { required: true, message: '请输入采购计划名称', trigger: 'blur' },
        ],
        purchaseModeType: [
          { required: true, message: '请选择采购计划', trigger: 'blur' },
        ],
      },
      pickerReleaseTimeDate: {
        disabledDate: (time) => {
          return new Date(time).getTime() <= Date.now() - 8.64e7;
        },
      },
      // 选择采购计划
      formPurchaseTypeList: [
        { id: 1, name: '选品下单' },
        { id: 2, name: '询比价' },
        { id: 3, name: '自行招标' },
        { id: 4, name: '委托招标' },
        { id: 5, name: '执行框架协议' },
      ],
      tableFormData: {
        tableData: [],
      },
      tableFormData2: [],
      numQuantity: 0,
      rowData: null,
      rules_table: {
        /* categoryCustomCode: [
          {
            required: true,
            validator: categoryCustomCode,
            trigger: 'blur',
          },
        ], */
        specifications: [
          {
            type: 'string',
            required: true,
            message: '请输入规格型号',
            trigger: 'blur',
          },
        ],
        categoryDesc: [
          { required: true, message: '请输入物料描述', trigger: 'blur' },
        ],
        categoryName: [
          { required: true, message: '请输入物料分类', trigger: 'blur' },
        ],
        baseUnitName: [
          { required: true, message: '请输入计量单位', trigger: 'change' },
        ],
        remainingQuantity: [
          {
            required: true,
            validator: validateRequiredQuantity,
            trigger: 'blur',
          },
        ],
        budgetaryPrice: [
          {
            required: false,
            validator: validateBudgetaryPriceQuantity,
            trigger: 'blur',
          },
        ],
        expectedArrivalDate: [
          { required: true, message: '请选择日期', trigger: 'blur' },
        ],
      },
      isDemandCreate: '',
    };
  },

  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
    budgetaryTotalAmount() {
      if (this.tableFormData.tableData.length) {
        let countNum = 0;
        this.tableFormData.tableData.forEach((item) => {
          countNum += currency(item.budgetaryPrice || 0).multiply(
            item.remainingQuantity || 0
          ).value;
        });
        this.formData.budgetaryTotalAmount = countNum.toFixed(2);
        return countNum !== 0 ? `${countNum.toFixed(2)}元` : '--';
      }
      return '--';
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
          this.formData.orgId = newVal.departmentId;
          this.formData.orgShortName = newVal.departmentName;
          this.formData.purchaseCompanyId = newVal.companyId;
          this.formData.purchaseCompanyName = newVal.companyName;
        }
      },
    },
  },
  created() {
    this.routeData = this.$route.query;
    // 创建 add / 编辑 change,edit
    // this.pageType = this.$route.query.pageType == "add" ? "创建" : "编辑";
    this.pageType = this.$route.query.pageType;
    this.isDemandCreate = this.$route.query.isDemandCreate;
    this.getRoutePathData();
    // this.getApproveFlag();
    this.checkAuth();
    this.queryApprovalProcessSwitch();
    if (this.$route.meta.formData && this.$route.meta.flagData) {
      this.showRemarkList = this.$route.meta.showRemarkList;
      this.formData = this.$route.meta.formData;
    }
  },
  mounted() {
    this.uploadUrl = enApi.enquiryFileUrl();
    setTimeout(() => {
      console.log(this.formData, 'formData');
    }, 3000);
  },
  methods: {
    // 批量修改数据
    bitchChangeData(data) {
      console.log(this.tableFormData, 'this.tableFormData.tableData');
      this.tableFormData.tableData.forEach((item) => {
        this.$set(item, this.bitchData.bitchChangeFlag, data);
      });
    },
    openDialog(flag, title) {
      this.bitchData.bitchChangeFlag = flag;
      this.bitchData.bitchChangeTitle = title;
      this.dataVisible = true;
    },
    closeDialog() {
      this.dataVisible = false;
    },
    // 附件名称
    getAttachmentName(row) {
      if (row?.length) {
        return row[0].attachmentName || '';
      }
      return '';
    },
    // 批量修改计划到货日期
    submitChangeTime(time) {
      this.tableFormData.tableData.forEach((item) => {
        item.expectedArrivalDate = time;
      });
    },
    // 查看需求计划详情
    handleDemandDetail(row) {
      const { purchaseDemandId } = row;
      this.$route.meta.tableFormData = this.tableFormData.tableData;
      this.$route.meta.formData = this.formData;
      this.$route.meta.showRemarkList =
        this.formData?.purchasePlanAttachmentAOList?.map((item) => {
          return {
            fileName: item.attachmentName || '',
            fileUrl: item.attachmentUrl || '',
          };
        }) || [];
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId },
      });
    },
    /* async getApproveFlag() {
      let res = await Api.approveList({ auditType: 4 });
      if (res.code == "200" && res.data.length) {
        if (res.data.length == 1) {
          this.formData.auditId = res.data[0].auditId;
          this.formData.auditName = res.data[0].auditName;
        }
        this.approvalList = res.data;
        this.approvalFlag = true;
      } else {
        this.approvalFlag = false;
      }
    }, */
    getRoutePathData() {
      if (this.$route.meta.tableFormData) {
        this.$route.meta.tableFormData.forEach((item) => {
          if (!item.specifications) {
            item.specifications = '无';
          }
        });
        this.tableFormData.tableData = this.$route.meta.tableFormData;
        // specifications

        console.log('getRoutePathData', this.tableFormData.tableData);
        return;
      }
      switch (this.$route.query.pageType) {
        case 'edit':
          this.setEditData();
          break;
        case 'change':
          this.setChangeData();
          break;
      }
    },

    async setEditData() {
      this.tableFormData.tableData = [];
      const routerData = this.$route.query.tableSelectData;
      routerData?.forEach((item) => {
        const obj = {
          specifications: item.specifications || '无',
          remainingQuantity: item.remainingQuantity,
          quantity: item.remainingQuantity,
          baseUnitName: item.baseUnitName,
          baseUnitNo: item.baseUnitNo,
          budgetaryPrice: item.budgetaryPrice,
          categoryCode: item.categoryCode,
          categoryCustomCode: item.categoryCustomCode,
          categoryDesc: item.categoryDesc,
          categoryId: item.categoryId,
          numFlag: item.numFlag,
          categoryName: item.categoryName,
          createMemberName: item.createMemberName,
          expectedArrivalDate: item.expectedArrivalDate,
          purchasePlanAttachmentAOList: [],
          purchaseDemandCode: item.purchaseDemandCode,
          purchaseDemandItemId: item.purchaseDemandItemId,
          purchaseDemandId: item.purchaseDemandId,
          orgShortName: item.orgShortName,
          purchaseDemandName: item.purchaseDemandName,
          purchaseDemandItemIdList: [],
          // imageNumber:item.imageNumber,
          // buyer:item.buyer,
          // partNumber:item.partNumber,
          // standard:item.standard,
          // remark:item.remark
        };
        this.tableFormData.tableData.push(obj);
      });

      // 判断产品批次号是不是全都一样
      if (this.judgeSame(routerData, 'productBatchNumber')) {
        this.formData.productBatchNumber = routerData[0].productBatchNumber;
      }

      this.cloneTableFormData = await _.cloneDeep(this.tableFormData.tableData);
      this.tableFormData.tableData = this.removeRepetition(
        this.tableFormData.tableData
      );

      this.cloneTableFormData?.forEach((item) => {
        this.tableFormData.tableData?.forEach((item2) => {
          // 如果有物料编码 把合并后的purchaseDemandItemId 保存 点击查看需要传
          if (
            `${item.categoryName}${item.categoryDesc}` ==
            `${item2.categoryName}${item2.categoryDesc}`
          ) {
            item2.purchaseDemandItemIdList.push(item);
            item2.purchaseDemandItemIdList.push(item2);
            // 若物料分类和物料编码相同 则将行项目合并为同一行展示
            item2.purchaseDemandItemIdList = this.removeRepetition2(
              item2.purchaseDemandItemIdList
            );
          }
        });
      });

      const allArr = [
        'imageNumber',
        'buyer',
        'partNumber',
        'standard',
        'remark',
      ];
      const sameArr = [];
      // 判断图号是不是全都一样
      if (this.judgeSame(routerData, 'imageNumber')) {
        sameArr.push('imageNumber');
      }
      // 判断订货方是不是全都一样
      if (this.judgeSame(routerData, 'buyer')) {
        sameArr.push('buyer');
      }
      // 判断件号是不是全都一样
      if (this.judgeSame(routerData, 'partNumber')) {
        sameArr.push('partNumber');
      }
      // 判断标准是不是全都一样
      if (this.judgeSame(routerData, 'standard')) {
        sameArr.push('standard');
      }
      // 判断备注是不是全都一样
      if (this.judgeSame(routerData, 'remark')) {
        sameArr.push('remark');
      }

      this.tableFormData.tableData?.forEach((item) => {
        let num = 0;
        item.purchaseDemandItemIdList?.forEach((i) => {
          num += Number(i.remainingQuantity);
        });
        item.remainingQuantity = num.toFixed(3);

        if (sameArr.length > 0) {
          allArr.forEach((allItem) => {
            if (sameArr.includes(allItem)) {
              this.$set(item, allItem, routerData[0][allItem]);
            } else {
              this.$set(item, allItem, '');
            }
          });
        }
      });
      this.tableFormData2 = await _.cloneDeep(this.tableFormData.tableData);
    },

    // 判断是不是全部一样
    judgeSame(arr, key) {
      const dataArr = arr.map((item) => item[key]);
      const arrSet = new Set(dataArr);
      if (arrSet.size === 1) {
        return true; // 一样
      }
      return false;
    },

    // 去重
    removeRepetition2(arr) {
      const obj = {};
      arr = arr.reduce(function (item, next) {
        obj[next.purchaseDemandItemId]
          ? ''
          : (obj[next.purchaseDemandItemId] = true && item.push(next));
        return item;
      }, []);
      return arr;
    },

    // 去重
    removeRepetition(arr) {
      const obj = {};
      arr = arr.reduce(function (item, next) {
        // 有物料编码时 判断物料分类和物料描述
        obj[next.categoryName + next.categoryDesc]
          ? ''
          : (obj[next.categoryName + next.categoryDesc] = item.push(next));
        return item;
      }, []);
      return arr;
    },

    async setChangeData() {
      const params = {
        companyId: Number(this.routeData.purchaseCompanyId),
        purchasePlanCode: this.routeData.purchasePlanCode,
        purchasePlanName: this.routeData.purchasePlanName,
        purchasePlanId: this.routeData.purchasePlanId,
      };
      const res = await Api.purchaseQueryDetail(params);
      if (res.code == '200') {
        const { purchasePlanItemVOList = [] } = res.data;
        console.log(purchasePlanItemVOList, 'purchasePlanItemVOList');
        /* purchasePlanItemVOList.forEach(item => {
          if (item?.purchasePlanAttachmentAOList?.length === 0) {
            this.$set(item, "purchasePlanAttachmentAOList", [
              {
                attachmentName: "",
                attachmentType: -1,
                //附件类型1:采购需求主表附件 2:采购需求明细附件
                attachmentUrl: "",
              },
            ]);
          }
        }); */
        this.tableFormData.tableData = [...purchasePlanItemVOList];
        console.log('setChangeData', this.tableFormData.tableData);

        this.tableFormData.tableData?.forEach((item) => {
          item.remainingQuantity = item.quantity;
          if (item.purchasePlanDemandItemVOList?.length) {
            item.numFlag = item.purchasePlanDemandItemVOList.length;
            item.purchaseDemandItemIdList = item.purchasePlanDemandItemVOList;
            item.purchaseDemandItemIdList?.forEach(
              (item) => (item.remainingQuantity = item.quantity)
            );
          }
          delete item.purchasePlanDemandItemVOList;
        });
        this.formData = res.data;
        this.formData.purchasePlanAttachmentAOList =
          res.data.purchasePlanAttachmentVOList;
        this.formData.purchasePlanItemAOList = [];
        /* this.formData.purchasePlanAttachmentAOList?.forEach(item => {
          let obj = {
            fileName: item.attachmentName || "",
            fileUrl: item.attachmentUrl || "",
          };
          this.showRemarkList.push(obj);
        }); */
        this.tableFormData2 = await _.cloneDeep(this.tableFormData.tableData);
      }
    },

    // 框架协议弹框
    selectAgreement() {
      this.queryAgreementForPurchaseByPage();
      this.agreementVisible = true;
    },

    // 采购商-框架协议分页列表查询
    async queryAgreementForPurchaseByPage() {
      delete this.agreementData.createTime;
      const res = await Api.queryAgreementForPurchaseByPage({
        ...this.agreementData,
      });
      if (res.code == '200') {
        this.agreementTableData = res.data.records;
        this.agreementDataTotal = res.data.total;
      }
    },

    resetPopupDataAgreement() {
      this.agreementVisible = false;
    },

    // 查询
    handleAgreementFilter(val) {
      this.agreementData = val;
      this.agreementData.startDate = val.createTime ? val.createTime[0] : '';
      this.agreementData.endDate = val.createTime ? val.createTime[1] : '';
      this.queryAgreementForPurchaseByPage();
    },
    // 重置
    handleAgreementReset() {
      this.agreementData = this.$options.data().agreementData;
      this.queryAgreementForPurchaseByPage();
    },
    // 框架协议详情
    handleSelectAgreement(row) {
      this.formData.protocolCode = row.agreementCode;
      this.formData.protocolId = row.agreementId;
      this.formData.supplierCompanyId = row.supplierCompanyId;
      this.formData.supplierCompanyName = row.supplierCompanyName;
      this.agreementTitleName = row.agreementName;
      this.agreementVisible = false;
    },
    // 框架协议弹框分页
    handleCurrentChange(row) {
      this.agreementData.pageNum = row;
      this.queryAgreementForPurchaseByPage();
    },
    handleSizeChange(val) {
      this.agreementData.pageNum = 1;
      this.agreementData.pageSize = val;
      this.queryAgreementForPurchaseByPage();
    },

    // 是否有配置审批流权限
    async checkAuth() {
      const resData = await enApi.hasAuthCode({
        authCode: '/approveSetting',
      });
      if (resData.code == 200) {
        this.authFlag = resData.data;
      }
    },

    // 返回上一页
    handleGoBack() {
      this.$confirm('取消后已填写信息将丢失，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$route.meta.showRemarkList = null;
          this.$route.meta.formData = null;
          this.$route.meta.tableFormData = null;
          this.$router.back();
        })
        .catch(() => {});
    },

    // 提交
    async handleSubmit() {
      if (!this.formData.purchasePlanItemAOList.length) {
        return this.$message.warning('请添加物料信息');
      }
      if (
        (!this.formData.protocolCode || !this.formData.protocolId) &&
        this.formData.purchaseModeType == 5
      ) {
        return this.$message.warning('请选择框架协议');
      }

      if (this.authFlag && this.ifSwitch && !this.formData.auditId) {
        return this.$message.warning('请选择审批流程');
      }

      /* if (!this.authFlag && !this.ifSwitch) {
        this.formData.auditId = "";
        this.formData.auditName = "";
      } */

      if (!this.ifSwitch) {
        this.formData.auditId = '';
        this.formData.auditName = '';
      }

      // 是否配置审批流
      this.formData.enableWorkflow = this.formData.auditId ? 1 : 0;
      this.formData.purchasePlanItemAOList.forEach((item) => {
        delete item.remainingQuantity;
        if (item.purchasePlanDemandItemVOList) {
          item.purchasePlanAttachmentAOList = item.purchasePlanDemandItemVOList;
        }
        if (
          item.purchasePlanAttachmentAOList?.length &&
          item.purchasePlanAttachmentAOList[0]?.attachmentType != 2
        ) {
          item.purchasePlanAttachmentAOList = [];
        }
      });
      let res = null;
      let url = '/plan/purchaseWayEdit';
      delete this.formData.purchasePlanDemandItemVOList;
      // delete this.formData.purchasePlanAttachmentVOList;
      delete this.formData.purchasePlanItemVOList;
      console.log(this.formData, '参数');
      if (this.submitFlag == 'save') {
        if (this.$route.query.pageType == 'change') {
          url = '/plan/purchaseQuery';
          res = await Api.purchasePlanUpdate(this.formData);
        } else {
          res = await Api.addPurchasePlan(this.formData);
        }
      } else {
        res = await Api.purchasePlanSubmit(this.formData);
      }

      if (res?.code == '200') {
        this.$message.success('操作成功');
        this.$route.meta.showRemarkList = null;
        this.$route.meta.formData = null;
        this.$route.meta.tableFormData = null;
        this.$router.push(url);
      }
    },

    // 第一个表单校验
    verifyformRef(type) {
      this.$refs.formRef1.validate((valid) => {
        if (valid) {
          this.submitFlag = type;
          this.verifyTableForm();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 表格表单验证
    verifyTableForm() {
      this.$refs.tableForm.validate(async (valid) => {
        if (valid) {
          this.tableFormData.tableData.forEach((item) => {
            if (item.purchaseDemandItemIdList?.length) {
              item.purchasePlanDemandItemAOList =
                item.purchaseDemandItemIdList.map((i) => {
                  return {
                    purchaseDemandItemId: i.purchaseDemandItemId,
                    purchaseDemandId: i.purchaseDemandId,
                    quantity: Number(i.remainingQuantity),
                    purchaseDemandCode: i.purchaseDemandCode,
                  };
                });
              item.quantity = Number(item.remainingQuantity);
              delete item.remainingQuantity;
              delete item.purchaseDemandItemIdList;
            }

            item.subtotal = currency(item.quantity).multiply(
              item.budgetaryPrice
            ).value;
          });

          this.formData.purchasePlanItemAOList = this.tableFormData.tableData;
          this.formData.purchasePlanItemAOList.forEach((item) => {
            delete item.numFlag;
            if (this.$route.query.pageType == 'add') {
              delete item.remainingQuantity;
            }
            if (item.purchasePlanAttachmentVOList?.length) {
              item.purchasePlanAttachmentAOList =
                item.purchasePlanAttachmentVOList;
            }

            /* if (item.enquiryDetailAttachmentList) {
              delete item.enquiryDetailAttachmentList;
            }
            if (item.purchasePlanAttachmentVOList) {
              delete item.purchasePlanAttachmentVOList;
            } */
          });
          console.log(
            this.formData.purchasePlanItemAOList,
            'this.formData.purchasePlanItemAOList'
          );
          this.$refs.formRef2.validate((valid) => {
            if (valid) {
              this.handleSubmit();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 关闭查看
    resetPopupDataLook() {
      this.detailTableData = [];
      this.lookVisible = false;
    },
    // 下载附件
    handleExportDatail(row) {
      if (row[0].attachmentUrl) {
        utils.downFile(row[0].attachmentUrl, row[0].attachmentName);
      }
    },

    // 查看
    handleLook(row) {
      setTimeout(() => {
        this.purchaseDemandItemIdList = row.purchaseDemandItemIdList;
        this.rowData = row;
        row.purchaseDemandItemIdList.forEach(
          (item) =>
            (item.expectedArrivalDate = item.expectedArrivalDate.substring(
              0,
              10
            ))
        );
        this.detailTableData = row.purchaseDemandItemIdList;
        this.lookVisible = true;
      }, 300);
    },

    // 校验附件上传
    checkUploadDesc(row) {
      console.log(row, '上传后的列表图片');
      if (
        (row.purchasePlanAttachmentAOList &&
          row.purchasePlanAttachmentAOList.length &&
          row.purchasePlanAttachmentAOList[0].attachmentName) ||
        (row.purchasePlanAttachmentVOList &&
          row.purchasePlanAttachmentVOList.length &&
          row.purchasePlanAttachmentVOList[0].attachmentName)
      ) {
        return '已上传';
      }
      return '上传';
    },

    getMaterialFile(file) {
      console.dir(file, '上传成功的文件数据');
      this.$set(
        this.tableFormData.tableData[this.clickTableIndex],
        'purchasePlanAttachmentAOList',
        [{}]
      );
      console.log(
        this.tableFormData.tableData[this.clickTableIndex]
          .purchasePlanAttachmentAOList,
        '文科'
      );
      /* this.tableFormData.tableData[this.clickTableIndex].purchasePlanAttachmentAOList = [
        {
          attachmentName: file.fileName,
          attachmentUrl: file.fileUrl,
          attachmentType: 2,
        },
      ];
       */
      console.log(this.tableFormData.tableData);
      this.$set(
        this.tableFormData.tableData[this.clickTableIndex]
          .purchasePlanAttachmentAOList[0],
        'attachmentName',
        file.fileName
      );
      this.$set(
        this.tableFormData.tableData[this.clickTableIndex]
          .purchasePlanAttachmentAOList[0],
        'attachmentUrl',
        file.fileUrl
      );
      this.$set(
        this.tableFormData.tableData[this.clickTableIndex]
          .purchasePlanAttachmentAOList[0],
        'attachmentType',
        2
      );
      this.$forceUpdate();
    },

    // 需求部门
    closeSelectDepartmentDialog() {
      this.selectDepartmentDialogShow = false;
    },
    // 添加物料
    getCurrentNode(options) {
      this.formData.orgShortName = options.shortFullName;
      this.formData.orgId = options.orgId;
      this.selectDepartmentDialogShow = false;
    },

    // 关联预选
    chooseData(val) {
      this.formData.budgetId = val.budgetId;
      this.formData.budgetName = val.budgetName;
    },

    // 批量导入
    // 得到批量导入后的数据
    getbatchImportList(val) {
      val.forEach((item, index) => {
        item.mySkuId = new Date().getTime() + index;
      });
      this.tableFormData.tableData = [...val, ...this.tableFormData.tableData];
      console.log(this.tableFormData.tableData, '导入excel数据');
      this.tableFormData.tableData.forEach((item) => {
        // item.remainingQuantity = item.quantity;
        this.$set(item, 'remainingQuantity', item.quantity);
        if (!item.enquiryDetailAttachmentList?.[0]) {
          // 数据一定的是响应的
          this.$set(item, 'purchasePlanAttachmentAOList', [
            { attachmentName: null, attachmentUrl: null, attachmentType: 0 },
          ]);
        } else {
          const { attachmentName, attachmentUrl } =
            item.enquiryDetailAttachmentList[0];
          const arr = [
            {
              attachmentName,
              attachmentUrl,
              attachmentType: 2,
            },
          ];
          this.$set(item, 'purchasePlanAttachmentAOList', arr);
        }
      });
    },

    // 判断审批流的开关
    async queryApprovalProcessSwitch() {
      const res = await Api.queryOderConfig();
      if (res.code == 200 && res.data) {
        const { data } = res.data.find((item) => item.dataType === 'orderPlan');
        this.ifSwitch = data === '41';
        if (this.ifSwitch) {
          console.log(data, 'datadatadata');
          this.getApprovalList();
        }
      } else {
        this.ifSwitch = false;
      }
    },

    toSetApprove() {
      // window.open('https://uat-yyzx.epec.com/#/approveSetting');
      this.$router.push('/approveSetting');
    },
    // 选择审批流
    openApproval() {
      this.showAuditMask = true;
    },
    // 审批流弹框
    getApprovalChain(val) {
      console.log(
        val,
        '审批流弹框审批流弹框审批流弹框审批流弹框审批流弹框审批流弹框'
      );
      this.formData.auditId = val.auditId;
      this.formData.auditName = val.auditName;
      console.log(this.formData.auditId, 'getApprovalChain');
    },
    // 获取审批信息
    async getApprovalList() {
      const res = await Api.approveList({ auditType: 4 });
      if (res.code == '200') {
        this.approvalList = res.data || [];
      } else {
        this.$message.warning('暂无审批流');
      }
    },

    // 获取计量单位
    async getBaseUnitName(categoryId) {
      this.baseUnitNameList = [];
      const res = await Api.selectCategoryUnitList({ categoryId });
      if (res.code == '200') {
        this.baseUnitNameList = res.data;
      }
    },
    // 选择计量单位
    baseUnitNameChange(categoryId, index) {
      console.log(categoryId, index);
      const { unitCode = '' } =
        this.baseUnitNameList.find((item) => item.unitCode) || {};
      this.tableFormData.tableData[index].baseUnitNo = unitCode;
    },

    // 得到备注下面附件
    getFileInfo(fileList) {
      console.log('附件：', fileList);
      if (fileList?.length) {
        this.formData.purchasePlanAttachmentAOList = fileList.map((item) => ({
          attachmentUrl: item.fileUrl,
          attachmentName: item.fileName,
          attachmentType: 1,
        }));
      } else {
        this.formData.purchasePlanAttachmentAOList = [];
      }
    },

    // 添加物料
    handleAddMaterial() {
      this.addMaterialVisible = true;
    },

    getMaterialList(val) {
      this.tableFormData.tableData.push(...val);
    },

    // 框架协议详情
    handleCodeDetail(row) {
      const { agreementId } = row;
      this.$router.push({
        path: '/plan/purchaseWayEdit/agreementDetail',
        query: {
          agreementId,
        },
      });
    },

    // 批量导入
    handleImportAll() {
      this.batchImportVisible = true;
    },

    // 选择预算按钮
    handleFocusBtn(type) {
      if (type == 'budget') {
        // 关联预算
        this.budgetVisible = true;
      } else {
        // 需求部门
        this.selectDepartmentDialogShow = true;
      }
    },

    handleSelectBudget(row) {
      cnsole.log(row);
    },
    // 输入校验
    handleInputBlur(row, index, type) {
      // 采购数量
      if (type == 'remainingQuantity') {
        const num = Number(row.remainingQuantity);
        if (isNaN(num)) {
          row.remainingQuantity = null;
          return this.$message.warning('请输入正确的采购数量');
        }
        if (row.purchaseDemandItemIdList?.length) {
          if (this.$route.query.pageType == 'edit') {
            this.computedEditData(row);
          }
          if (this.$route.query.pageType == 'change') {
            this.computedChangeData(row);
          }
        } else {
          row.quantity = Number(row.remainingQuantity).toFixed(3);
        }
      }

      // 金额
      if (type == 'budgetaryPrice') {
        const num = Number(row.budgetaryPrice);
        if (isNaN(num)) {
          row.budgetaryPrice = null;
          return this.$message.warning('请输入正确的概算单价');
        }
        if (num > 9999999.99) {
          return this.$message.warning(`单价不可超过9999999.99`);
        }

        row.budgetaryPrice = num.toFixed(2);
      }
    },

    // 修改的数据
    computedChangeData(row) {
      if (row.totalRemainingQuantity < Number(row.remainingQuantity)) {
        row.remainingQuantity = null;
        return this.$message.warning('采购数量不能超过剩余采购数量');
      }
      const detailList = row.purchaseDemandItemIdList;
      row.remainingQuantity = Number(row.remainingQuantity).toFixed(3);
      let remaining = row.remainingQuantity;
      for (let i = 0; i < detailList.length; i++) {
        const current = detailList[i].itemRemainingQuantity;
        detailList[i].remainingQuantity = Math.min(
          current,
          Math.max(remaining, 0)
        );
        if (remaining > 0) {
          remaining = (remaining - current).toFixed(3);
        }
      }
    },
    // 编辑
    computedEditData(row) {
      const detailList = row.purchaseDemandItemIdList;
      row.remainingQuantity = Number(row.remainingQuantity).toFixed(3);
      let remaining = row.remainingQuantity;
      for (let i = 0; i < detailList.length; i++) {
        const current = detailList[i].quantity;
        detailList[i].remainingQuantity = Math.min(
          current,
          Math.max(remaining, 0)
        ).toFixed(3);
        if (remaining > 0) {
          remaining -= current.toFixed(3);
        }
      }
      if (remaining > 0) {
        row.remainingQuantity = null;
        return this.$message.warning('采购数量不能超过剩余采购数量');
      }
    },

    // 附件上传
    uploadDesc(index, row) {
      console.log(row);
      this.clickTableIndex = index;
      this.materialFileVisible = true;
      this.showFileList = [];
      if (row?.purchasePlanAttachmentVOList?.length) {
        this.showFileList = [
          {
            name: row.purchasePlanAttachmentVOList[0].attachmentName,
            url: row.purchasePlanAttachmentVOList[0].attachmentUrl,
          },
        ];
      }
      if (row?.purchasePlanAttachmentAOList?.length) {
        this.showFileList = [
          {
            name: row.purchasePlanAttachmentAOList[0].attachmentName,
            url: row.purchasePlanAttachmentAOList[0].attachmentUrl,
          },
        ];
      }
    },

    // 删除商品
    handleDelMaterial(index) {
      this.tableFormData.tableData.splice(index, 1);
    },

    // table滚动 设置最大高度
    bindMaxHeight() {
      if (this.maxHeight) {
        return { maxHeight: this.maxHeight };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.table-handle-btn {
  color: #0064c8;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.err-btn {
  color: #f0250f;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.steps-box {
  box-sizing: border-box;
  padding: 20px;
}
.submit-box {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.header-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  width: 100%;
  margin-bottom: 10px;
  text-align: center;
}

.btn-th {
  border-radius: 0;
  margin-left: 10px;
}
.importAll-steps {
  margin: 0 auto 20px;
  justify-content: center;
  box-sizing: border-box;
  padding: 10px 0;
  border: 1px solid #d9d9d9;
}
.importAll-upload {
  ::v-deep .tips-Message {
    left: 90px !important;
  }
}
.importAll-dialog {
  ::v-deep .el-dialog__body {
    padding: 30px 60px;
  }
}
.el-divider--horizontal {
  margin: 10px 0;
}

.dialog-footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.commodity-list {
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  position: relative;

  .custom-empty {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 60px;
    margin-top: -30px;
    margin-left: -30px;
  }
  &:last-child {
    margin-top: 10px;
  }

  .title {
    color: #333;
    height: 44px;
    line-height: 44px;
    background: #f5f5f5;
    padding-left: 20px;
    border-bottom: 1px solid #d9d9d9;
    font-size: 16px;
    font-weight: bold;
  }

  ::v-deep .el-form-item {
    margin-bottom: 18px;
    .el-input__inner {
      border-radius: 0;
    }
    .el-textarea__inner {
      border-radius: 0;
    }
    .el-form-item__label {
      line-height: 32px;
    }
    .el-form-item__content {
      line-height: 32px;
    }
  }

  .table-content {
    .del-btn {
      color: #f0250f;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    ::v-deep .el-table {
      th.must div:before {
        content: '*';
        color: #ff1818;
      }
      th.el-table__cell > .cell {
        font-weight: normal;
        font-size: 14px;
      }
    }
  }
  .commodity-content {
    padding: 0 10px 10px 10px;
    .set-type {
      line-height: 52px;
      i {
        font-size: 20px;
        cursor: pointer;
        &:hover {
          color: #2587ff;
        }
      }
    }
    .handle-btn {
      margin-top: 10px;
      .el-button {
        border-radius: 0;
      }
    }

    .add-table-handle-btn {
      margin-top: 10px;
      line-height: 38px;
      text-align: center;
      border: 1px dotted #d9d9d9;
      span {
        cursor: pointer;
      }
    }
  }

  .approval {
    // padding-top: 0;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .info {
      display: flex;
      align-items: center;
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
  }
  .enquiry-form {
    .file-name {
      margin-right: 10px;
      color: #0064c8;
      cursor: pointer;
    }
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 80%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      width: 80%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-textarea {
      width: 80%;
      .el-textarea__inner {
        border-radius: 0;
      }
    }

    .address-btn {
      color: #0064c8;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

::v-deep .el-table th.el-table__cell {
  background-color: #f5f5f5 !important;
}
.table-desc {
  ::v-deep .el-form-item__content {
    line-height: normal !important;
  }
}
::v-deep .el-upload-list {
  width: 100% !important;
  display: flex;
}

::v-deep .el-table .verify:nth-of-type(6) :before {
  content: '*';
  color: #ff1818;
  margin-right: 2px;
}
/* ::v-deep .el-table .verify:nth-of-type(3) :before {
  content: '*';
  color: #ff1818;
  margin-right: 2px;
} */
.table-active-i {
  color: #ff1818;
  margin-right: 2px;
}
.produc-type {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.agreement-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
  }
}
.close-btn {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: right;
}
.btn-other {
  border-color: #2587ff;
  color: #2587ff;
  border-radius: 0;
}
.select-agreement {
  width: 100%;
  height: 30px;
  display: flex;
  margin: 20px 0 10px;
  padding: 0 30px;
  box-sizing: border-box;
  align-items: center;
}
.remark-upload {
  ::v-deep .el-upload-list__item {
    width: 20%;
  }
  ::v-deep .el-upload-list__item:first-child {
    margin-top: 5px !important;
  }
}
.btn-main-more {
  display: inline-block;
  margin-right: 10px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #2587ff;
  -webkit-user-select: none;
  border-radius: 0px;
  cursor: pointer;
  &:hover {
    background: #126edf;
  }
}
.btn-main {
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #fff;
  background: #2587ff;
  cursor: pointer;
  -webkit-user-select: none;
  border-radius: 0px;
  &:hover {
    background: #126edf;
  }
}
.btn-other {
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  color: #004898;
  background: #ffffff;
  border: 1px solid #004898;
  cursor: pointer;
  -webkit-user-select: none;
  border-radius: 4px;
  &:hover {
    color: #004898;
    border: 1px solid #004898;
    background: #e8f3ff;
  }
}
</style>
